
export default class AttendeeLoginClient {
  constructor(baseUrl, eventId, environment, userType) {
    this.baseUrl = baseUrl;
    this.eventId = eventId;
    this.environment = environment;
    this.userType = userType;
  }

  async authorize() {
    window.location.assign(`${this.baseUrl}attendeeLogin/${this.eventId}/authorize?environment=${this.environment}&userType=${this.userType}`);
  }
}
